import React from "react";
import { Play, Pause, X, Loader2 } from "lucide-react";
import { usePlayer } from "@/context/PlayerContext";
import Waveform from "@/components/Waveform";

const fmt = (s) => {
  if (!s || isNaN(s)) return "0:00";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60).toString().padStart(2, "0");
  return `${m}:${sec}`;
};

export default function PersistentPlayer() {
  const { current, playing, progress, duration, loading, toggle, seek, stop } = usePlayer();
  if (!current) return null;
  const pct = duration ? progress / duration : 0;
  return (
    <div data-testid="persistent-player"
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-zinc-200 bg-white/85 backdrop-blur-xl shadow-[0_-4px_24px_rgba(0,0,0,0.06)]">
      <div className="container-x flex items-center gap-4 py-3">
        <button onClick={toggle} data-testid="player-toggle"
          aria-label={playing ? "Pause" : "Play"}
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-brand-violet text-white transition hover:bg-brand-violetHover focus:outline-none focus:ring-2 focus:ring-brand-violet">
          {loading ? <Loader2 size={18} className="animate-spin" /> : playing ? <Pause size={18} className="fill-white" /> : <Play size={18} className="fill-white ml-0.5" />}
        </button>
        <div className="hidden sm:flex min-w-0 w-48 flex-col">
          <span className="truncate font-heading text-sm font-bold text-zinc-900">{current.name}</span>
          <span className="truncate text-xs text-zinc-500">{current.sub}</span>
        </div>
        <div className="flex flex-1 items-center gap-3">
          <span className="hidden md:block w-10 text-right text-xs font-mono text-zinc-500">{fmt(progress)}</span>
          <Waveform seed={current.key} count={64} height={32} className="flex-1"
            active progress={pct} onSeek={seek} />
          <span className="hidden md:block w-10 text-xs font-mono text-zinc-500">{fmt(duration)}</span>
        </div>
        <button onClick={stop} data-testid="player-close" aria-label="Close player"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-zinc-400 hover:bg-zinc-100 hover:text-zinc-700">
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
